export default "__VITE_ASSET__BsMYt8tb__"